import {isLocalStorageQuotaExceeded} from "./systemHelpers";

export function setItem(playerUID = '', itemName, item) {
    try {
        localStorage.setItem(playerUID + itemName, JSON.stringify(item));
    } catch (e) {
        if (isLocalStorageQuotaExceeded(e)) { // storage full
            console.warn('Browser local storage is full, open bets cannot be cached.');
        }
    }
}

export function getItem(playerUID = '', itemName) {
    let item = localStorage.getItem(playerUID + itemName);
    try {
        return JSON.parse(item);
    } catch (e) {
        console.info("A problem has occurred while parsing json.")
    }
    return item;
}



// WEBPACK FOOTER //
// ./src/helpers/localStorageHelpers.js